import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesChecklist() {
  const items = [{
    title: 'Contenido 100% argentino',
    desc: 'Ríos, cuencas, acuíferos, casos reales y datos de Argentina'
  }, {
    title: 'Material listo para el aula',
    desc: 'Sin adaptar, sin buscar, sin completar'
  }, {
    title: 'Actividades variadas',
    desc: 'Para distintos niveles y estilos de aprendizaje'
  }, {
    title: 'Evaluaciones con clave',
    desc: 'Listas para usar el lunes siguiente'
  }, {
    title: 'Vocabulario técnico explicado',
    desc: 'Accesible para primaria y riguroso para secundaria'
  }, {
    title: 'Alineado con los NAP',
    desc: 'Conexión curricular explícita en cada módulo'
  }, {
    title: '4 Bonos estratégicos',
    desc: 'Actividades, evaluaciones, atlas y planificaciones'
  }, {
    title: 'Garantía de 7 días',
    desc: 'Sin preguntas ni formularios'
  }, {
    title: 'Acceso inmediato',
    desc: 'Descarga directa tras la compra'
  }, {
    title: 'Actualizaciones gratuitas',
    desc: 'Acceso de por vida al material'
  }];
  return <section className="py-12 bg-[#0a1428] border-y border-slate-500/30" data-id="element-147">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-148">
        <h3 className="text-2xl font-bold text-center mb-10 text-white" data-id="element-149">
          ✅ TODOS LOS TOMOS INCLUYEN:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-150">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 p-3 rounded-lg hover:bg-[#0f1d35]/50 transition-colors" data-id="element-151">
              <CheckCircle2 className="w-5 h-5 text-slate-300 shrink-0 mt-0.5" data-id="element-152" />
              <div data-id="element-153">
                <span className="text-slate-200 font-bold text-[16px] block" data-id="element-154">
                  {item.title}
                </span>
                <span className="text-slate-400 text-sm" data-id="element-155">{item.desc}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}